import type { TMFORequiredDocumentLink } from '@/pages/MFOPage/components/MFORequiredDocuments/types'
import { messages } from './messages'

export const REQUIRED_DOCUMENT_LINKS: Readonly<TMFORequiredDocumentLink[]> = [
  { url: 'https://disk.yandex.ru/i/P49on63Ef0YCSQ', text: messages.questionnaire },
  { url: 'https://disk.yandex.ru/i/UNtXWMv3wVOjLQ', text: messages.landBankRegistry },
  { url: 'https://disk.yandex.ru/i/QVggXoxNm-iJQg', text: messages.bKIForLegalEntities },
  { url: 'https://disk.yandex.ru/i/AqZwLUHFAZeOVw', text: messages.bKIForIndividual },
  { url: 'https://disk.yandex.ru/i/b9KdnuOdly12SA', text: messages.documentList },
  { url: 'https://disk.yandex.ru/i/cmuey-p2ORwecA', text: messages.personalDataProcessing },
]
